import axios from "axios";
import logger from "./logService";
import authService from "./authService";
import { TOKEN_KEY } from "./../utils/constants";

axios.interceptors.response.use(null, (error) => {
  const expected_error =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expected_error) {
    logger.Log(error);
    return;
  }

  if (error.response.status === 401) {
    //TODO: Add Toaster
    authService.logout();
    window.location = "/login";
  }

  return Promise.reject(error);
});

axios.interceptors.request.use(function (config) {
  const token = getToken();

  if (token !== null) config.headers.Authorization = "Bearer " + token;

  return config;
});

const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

const httpService = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  getToken,
};

export default httpService;
